import Vue from "vue";
import axios from "axios";
import { baseServerUrl } from "../config/index";


export function request(config) {
  const instance = axios.create({
    baseURL: `${baseServerUrl}`,
    timeout: 120000, //设置2分钟 超时
  });

  instance.interceptors.request.use(
    (config) => {
      return config;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
  instance.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (err) => {
      if (err.code == "ECONNABORTED" || err.code == "ERR_NETWORK") {
        Vue.prototype.$message.error("请求超时，请检查网络状态");
      }
      return Promise.reject(err);
    }
  );
  return instance(config);
}



// WEBPACK FOOTER //
// ./src/network/request.js